<!-- @format -->

<mat-progress-bar [class.visible]="loader.useRef('router').value$ | async" [value]="loader.useRef('router').value$ | async" class="progress-bar" mode="determinate"></mat-progress-bar>
